import { createContext } from 'react'

export type DropdownContextValue = {
  close: () => void
}

export const DropdownContext = createContext<DropdownContextValue>({
  close: () => undefined,
})
